// types
import type { TabsParent } from "@swiggy-private/dls-web-core/dist/components/BottomNavigation";

// constants
import { BottomNavigationTabsHome } from "@swiggy-private/dls-web-core/dist/components/BottomNavigation";
import { IDigitalMenuConfigData, ScreenNames } from "@swiggy-private/portal-dineout-context";
import type { ITableContext } from "@swiggy-private/portal-dineout-context";
import { getV2ConfigFlags } from "@swiggy-private/portal-dineout-ui";
import { BOTTOM_NAV_VALUE_KEY } from "./constants";
import { ROUTES } from "../../constants";

const getCurrentScreenName = (route: string): ScreenNames => {
    if (route.includes(ROUTES.SEARCH)) {
        return ScreenNames.SEARCH;
    }
    if (route.includes(ROUTES.MENU)) {
        return ScreenNames.MENU;
    }
    if (route.includes(ROUTES.TRACK)) {
        return ScreenNames.ORDERS;
    }
    if (route.includes(ROUTES.CART)) {
        return ScreenNames.CART;
    }
    if (route.includes(ROUTES.COLLECTIONS)) {
        return ScreenNames.COLLECTION;
    }
    return ScreenNames.MENU;
};

const getIndexByTab = (tab: TabsParent): number => {
    switch (tab) {
        case BottomNavigationTabsHome.MENU:
            return 1;
        case BottomNavigationTabsHome.SEARCH:
            return 2;
        case BottomNavigationTabsHome.MY_ORDERS:
        case BottomNavigationTabsHome.MY_ORDERS_NOTIFICATION:
            return 3;
        default:
            return 1;
    }
};

export const getAnalyticsData = ({
    tab,
    index,
    route,
    objectName,
    tableNo,
    config,
    tableContext,
}: {
    tab: TabsParent;
    index?: number;
    route: string;
    objectName: string;
    tableNo: string;
    config: IDigitalMenuConfigData | null;
    tableContext: ITableContext;
}) => {
    if (index === undefined) {
        index = getIndexByTab(tab);
    }
    const { tableId = "", restaurantId = "", parentOrderId = "" } = tableContext;
    const { isV2, isV2InApp } = getV2ConfigFlags(config);
    const theme = isV2InApp ? config?.themeInfo?.theme : undefined;
    return {
        screenName: getCurrentScreenName(route),
        objectName,
        objectValue: "-",
        objectPosition: String(index),
        context: JSON.stringify({
            [BOTTOM_NAV_VALUE_KEY]: tab,
            table_id: tableId,
            table_no: tableNo,
            restaurant_id: restaurantId,
            parentOrderId,
            is_v2_config: isV2,
            theme,
        }),
    };
};

export const getShownTabs = (config: IDigitalMenuConfigData | null, shouldFetchPartnerOrder: boolean) => {
    const showTabs: TabsParent[] = [
        BottomNavigationTabsHome.MENU,
        BottomNavigationTabsHome.SEARCH,
        shouldFetchPartnerOrder ? BottomNavigationTabsHome.MY_ORDERS_NOTIFICATION : BottomNavigationTabsHome.MY_ORDERS,
    ];

    const { conversionNudgesConfig } = config ?? {};
    const isPayBillNudgeEnabled =
        conversionNudgesConfig?.enableConversionNudges && conversionNudgesConfig?.nudges?.payBillBottomNav?.enabled;

    if (isPayBillNudgeEnabled) {
        showTabs.push(BottomNavigationTabsHome.PAYBILL);
    }

    return showTabs;
};
